import emptySplitApi from "../utils/rtk";
import { User } from "../types/User";
import { END_POINTS } from "../helpers";
import { CommonBody, ProductType } from "../types/General";
import { AnyIfEmpty } from "react-redux";

type CommonResponseType = {
  status: number;
  message: string;
};
type ProductData = {
  length: number;
  start: number;
  total_records: number;
  response_object: ProductType[];
};

type BestProductParams = {
  id: number;
  body: {
    today_deal?: boolean;
    daily_best_product?: boolean;
  };
};

export const productsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    productList: builder.mutation<
      CommonResponseType & { data: ProductData },
      { body: any }
    >({
      query: ({ body }) => ({
        url: END_POINTS.productsListing,
        method: "POST",
        body,
      }),
    }),

    updateProductApprovalStatus: builder.mutation<
      CommonResponseType & { data: any },
      { id: any; status: number }
    >({
      query: ({ id, status }) => ({
        url: `${END_POINTS.updateProduct}${id}/`,
        method: "PUT",
        body: { product_status: status },
      }),
    }),
    getProductById: builder.query<
      CommonResponseType & { data: ProductType },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.productById}${id}/`,
        method: "GET",
      }),
    }),

    updateBestProducts: builder.mutation<
      CommonResponseType & { data: any },
      BestProductParams
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.bestProducts}${id}/`,
        method: "POST",
        body,
      }),
    }),

    getAllProductCount: builder.mutation<
      CommonResponseType & { data: any },
      {}
    >({
      query: (body) => ({
        url: END_POINTS.productCount,
        method: "POST",
        body,
      }),
    }),

    addProduct: builder.mutation<
      CommonResponseType & { data: any },
      { body: any }
    >({
      query: (body) => ({
        url: END_POINTS.addProduct,
        method: "POST",
        body,
      }),
    }),

    updateProduct: builder.mutation<
      CommonResponseType & { data: any },
      { id: any; body: any }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.editProduct}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    getAllQuoteCount: builder.mutation<CommonResponseType & { data: any }, {}>({
      query: (body) => ({
        url: END_POINTS.quoteCount,
        method: "POST",
        body,
      }),
    }),

    productByVendor: builder.query<
      CommonResponseType & { data: ProductType },
      {}
    >({
      query: ({}) => ({
        url: `${END_POINTS.productByVendor}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useProductListMutation,
  useUpdateProductApprovalStatusMutation,
  useLazyGetProductByIdQuery,
  useUpdateBestProductsMutation,
  useGetAllProductCountMutation,
  useAddProductMutation,
  useUpdateProductMutation,
  useGetAllQuoteCountMutation,
  useLazyProductByVendorQuery,
} = productsApi;
